var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-items-center px-4 py-3 text-right"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }